import { render, staticRenderFns, recyclableRender, components } from "./select.vue?vue&type=template&id=0e0a4d24&scoped=true&"
var renderjs
import script from "./select.vue?vue&type=script&lang=js&"
export * from "./select.vue?vue&type=script&lang=js&"
import style0 from "./select.vue?vue&type=style&index=0&id=0e0a4d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0a4d24",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "shop/select/select.vue"
export default component.exports